(function () {
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Pointer-driven tilt and foil position on the member card */
  function tilt(stage) {
    var card = stage.querySelector('[data-mbr-card]');
    if (!card || !motionOk || !finePointer) return;
    var frame = 0;
    var px = 0.5, py = 0.5;

    function paint() {
      frame = 0;
      card.style.setProperty('--mbr-mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--mbr-my', (py * 100).toFixed(1) + '%');
      card.style.setProperty('--mbr-rx', ((0.5 - py) * 16).toFixed(2) + 'deg');
      card.style.setProperty('--mbr-ry', ((px - 0.5) * 22).toFixed(2) + 'deg');
    }

    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = card.getBoundingClientRect();
      px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      card.classList.add('is-live');
      if (!frame) frame = requestAnimationFrame(paint);
    });
    stage.addEventListener('pointerleave', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      card.classList.remove('is-live');
      ['--mbr-mx', '--mbr-my', '--mbr-rx', '--mbr-ry'].forEach(function (p) { card.style.removeProperty(p); });
    });
  }

  /* Mirror the racer name, first number choice and machine type from the product form onto the card.
     A combined names-and-numbers field supplies the first name and first number. */
  function mirror() {
    var nums = document.querySelectorAll('[data-mbr-num]');
    var types = document.querySelectorAll('[data-mbr-type]');
    var names = document.querySelectorAll('[data-mbr-name]');
    if (!nums.length) return;

    function fieldName(el) {
      return (el.getAttribute('name') || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('data-name') || '');
    }
    function set(list, text) {
      Array.prototype.forEach.call(list, function (n) { n.textContent = text; });
    }
    function onField(e) {
      var el = e.target;
      if (!el || !el.closest || !el.closest('form[action*="/cart/add"]')) return;
      var name = fieldName(el);
      if (/racer names?\b.*\bnumbers?\b/i.test(name)) {
        var parts = String(el.value || '').split(/[,\n]/);
        var first = '', firstNum = '';
        parts.forEach(function (p) {
          var t = p.replace(/\s+/g, ' ').trim();
          if (!t) return;
          if (/^\d{1,3}$/.test(t)) { if (!firstNum) firstNum = t; }
          else if (!first) first = t.slice(0, 40);
        });
        Array.prototype.forEach.call(names, function (n) {
          n.textContent = first || 'Racer name';
          n.classList.toggle('is-empty', !first);
        });
        set(nums, firstNum || '—');
      } else if (/racer name/i.test(name)) {
        var full = String(el.value || '').replace(/\s+/g, ' ').trim().slice(0, 40);
        Array.prototype.forEach.call(names, function (n) {
          n.textContent = full || 'Racer name';
          n.classList.toggle('is-empty', !full);
        });
      } else if (/(first|1st) choice/i.test(name)) {
        var digits = String(el.value || '').replace(/\D/g, '').slice(0, 3);
        set(nums, digits || '—');
      } else if (/vehicle type/i.test(name)) {
        if (el.type === 'radio' && !el.checked) return;
        var v = String(el.value || '').trim();
        set(types, /^(ATV|UTV)$/i.test(v) ? v.toUpperCase() : '');
      }
    }
    document.addEventListener('input', onField, true);
    document.addEventListener('change', onField, true);
  }

  /* Product options field order and backup-number reveal.
     Fields are rendered by the product options app inside the cart form. Wrappers are moved within
     their own container only; inputs, names and required flags are left as rendered.
     Order: class, vehicle type, racer name, first choice, then the rest in rendered order.
     Second and third choice stay collapsed behind a button until opened or filled. */
  var RANKS = [
    [/\bclass\b/i, 0],
    [/vehicle type/i, 1],
    [/racer names?\b/i, 2],
    [/(first|1st) choice/i, 3],
    [/(second|2nd) choice/i, 4],
    [/(third|3rd) choice/i, 5]
  ];
  var BACKUP_RANKS = [4, 5];
  var opened = {};

  function fieldOf(wrap) {
    return wrap.querySelector('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
  }
  function rankOf(wrap) {
    var el = fieldOf(wrap);
    var name = el ? el.getAttribute('name') || '' : '';
    for (var i = 0; i < RANKS.length; i++) if (RANKS[i][0].test(name)) return RANKS[i][1];
    return -1;
  }

  function arrange(root) {
    var wraps = Array.prototype.filter.call(root.children, function (n) {
      return n.classList.contains('selector-wrapper') && fieldOf(n);
    });
    if (!wraps.length) return;
    var items = wraps.map(function (w, i) {
      var r = rankOf(w);
      return { w: w, r: r, key: (r < 0 ? 100 : r) * 1000 + i };
    });
    var sorted = items.slice().sort(function (a, b) { return a.key - b.key; });
    var moved = sorted.some(function (it, i) { return it.w !== wraps[i]; });
    if (moved) {
      var anchor = wraps[wraps.length - 1].nextSibling;
      sorted.forEach(function (it) { root.insertBefore(it.w, anchor); });
    }
    backups(root, sorted);
  }

  function backups(root, items) {
    var byRank = {};
    items.forEach(function (it) { if (it.r >= 0) byRank[it.r] = it.w; });
    var first = byRank[3];
    var hidden = [];
    var last = first;
    BACKUP_RANKS.forEach(function (r) {
      var w = byRank[r];
      if (!w || !first) return;
      var el = fieldOf(w);
      if (el && String(el.value || '').trim()) opened[r] = true;
      if (el && el.required) opened[r] = true;
      if (!w.id) w.id = 'mbr-backup-' + r;
      var shut = !opened[r];
      w.classList.toggle('mbr-backup-hidden', shut);
      if (shut) hidden.push(w);
      else last = w;
    });

    var btn = root.querySelector('.mbr-backup-add');
    if (!hidden.length || !first) {
      if (btn) btn.remove();
      return;
    }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mbr-backup-add';
      btn.addEventListener('click', function () {
        var next = root.querySelector('.selector-wrapper.mbr-backup-hidden');
        if (!next) return;
        opened[rankOf(next)] = true;
        arrange(root);
        var el = fieldOf(next);
        if (el) el.focus();
      });
    }
    var anyOpen = BACKUP_RANKS.some(function (r) { return opened[r]; });
    btn.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M8 2v12M2 8h12" fill="none" stroke="currentColor" stroke-width="2"/></svg>' +
      (anyOpen ? 'Add another backup number' : 'Add a backup number') +
      '<span class="visually-hidden"> (optional)</span>';
    btn.setAttribute('aria-controls', hidden[0].id);
    if (btn.previousElementSibling !== last || btn.parentNode !== root) last.insertAdjacentElement('afterend', btn);
  }

  function formFields() {
    var root = document.querySelector('form[action*="/cart/add"] #bcpo, #bcpo');
    if (root) arrange(root);
  }

  function watchFields() {
    var pending = 0;
    function run() { pending = 0; formFields(); }
    formFields();
    new MutationObserver(function (list) {
      var relevant = list.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.id === 'bcpo' || n.classList.contains('selector-wrapper') || (n.querySelector && n.querySelector('#bcpo, .selector-wrapper')));
        });
      });
      if (relevant && !pending) pending = requestAnimationFrame(run);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbr-stage]'), tilt);
    mirror();
    watchFields();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
